import * as styles from './index.module.scss';
import { observer } from 'mobx-react';
import { useNavigate, useParams } from 'react-router-dom';
import { useEffect, useRef } from 'react';
import { StagesStore } from '../../../../../DataSource/Stores/Cabinet/StagesStore';
import { Collapse, Flex, message } from 'antd';
import Icon from '../../../../ui/Icon';
import Clickable from '../../../../ui/Clickable';
import IconButton from '../../../../ui/IconButton';
import { SwipeableButton } from 'react-swipeable-button';
import CommentsBlock from '../CommentsBlock';
import ReferenceBlock from '../ReferenceBlock';
import { UpOutlined } from '@ant-design/icons';
import dayjs from 'dayjs';

const JobPage = () => {
  const { id: workspaceId, jobId } = useParams();
  const navigate = useNavigate();
  const swipeableButtonRef = useRef<SwipeableButton | null>(null);
  const job = StagesStore.dataJobs.job;

  useEffect(() => {
    if (!workspaceId || !jobId) return;

    StagesStore.getJobsId(workspaceId, jobId).catch((e) => {
      console.error(e);
    });
  }, []);

  const copy = async (value?: string) => {
    if (!value) {
      message.error('Ошибка');
      return;
    }

    try {
      await navigator.clipboard.writeText(value);
      message.info('Скопировано', 2);
    } catch (e) {
      console.error(e);
    }
  };

  const handleSwipe = async () => {
    if (!workspaceId || !jobId) return;

    swipeableButtonRef.current?.buttonReset();

    await StagesStore.updateJobStage(workspaceId, jobId, '66e194a01725b77d117c4d5a');
    if (StagesStore.jobUpdateError) {
      message.error('Ошибка');
    } else {
      message.info('Успешно');
      navigate(`/workspaces/${workspaceId}/mobile/in-work`);
    }
  };

  const expandIcon = ({ isActive }: any) => (
    <UpOutlined style={{ transform: isActive ? 'rotate(180deg)' : 'rotate(0deg)' }} />
  );

  return (
    <Flex vertical gap={24}>
      <Clickable
        className={styles.backBtn}
        onClick={() => navigate(`/workspaces/${workspaceId}/mobile/new`)}
      >
        <Icon slug="arrow_back" />
        Все "Новые"
      </Clickable>

      <Flex vertical gap={12}>
        <p className={styles.name}>{job?.name}</p>

        <Flex vertical gap={8}>
          <div className={styles.field}>
            <p className={styles.label}>Job ID:</p>
            <Flex align="center" gap={8}>
              <p className={styles.value}>{job?.jobId}</p>
              <IconButton
                icon="copy_icon"
                variant="clear"
                size="sm"
                onClick={() => copy(job?.jobId)}
              />
            </Flex>
          </div>

          <div className={styles.field}>
            <p className={styles.label}>Bitrix ID:</p>
            <Flex align="center" gap={8}>
              <p className={styles.value}>{job?.externalId?.bitrixId}</p>
              <IconButton
                icon="copy_icon"
                variant="clear"
                size="sm"
                onClick={() => copy(job?.externalId?.bitrixId)}
              />
            </Flex>
          </div>
        </Flex>

        {job?.jobData && <ReferenceBlock jobData={job.jobData} expandIcon={expandIcon} />}

        <Collapse
          items={[
            {
              key: '1',
              label: 'СРОКИ',
              children: (
                <div className={styles.field}>
                  <p className={styles.label}>Цель</p>
                  <Flex align="center" gap={8}>
                    <p className={styles.label}>{dayjs(job?.targetDate).format('HH : mm')}</p>
                    <p className={styles.label}>•</p>
                    <p className={styles.label}>{dayjs(job?.targetDate).format('DD/MM/YY')}</p>
                  </Flex>
                </div>
              ),
            },
          ]}
          expandIcon={expandIcon}
          expandIconPosition="right"
          bordered={false}
          defaultActiveKey={[1]}
          ghost
        />

        {!!job?.comments?.length && (
          <CommentsBlock comments={job.comments} expandIcon={expandIcon} />
        )}
      </Flex>

      <SwipeableButton
        ref={swipeableButtonRef}
        text="Взять в работу"
        textColor="white"
        sliderColor="white"
        sliderIconColor="#E1A719"
        sliderTextColor="#E1A719"
        circle
        noAnimate
        onSuccess={handleSwipe}
      />
    </Flex>
  );
};

export default observer(JobPage);
